import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDizzy } from '@fortawesome/pro-regular-svg-icons/faDizzy'

export const ServerErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 4rem;
    padding-bottom: 4rem;
    height: 100%;

    p {
        font-size: 1.1rem;
    }
`

const ServerErrorMessage = ({
    url = '/',
    message = 'Oops. Something went wrong retrieving this page.',
    buttonLabel = 'Go to Dashboard',
}) => (
    <ServerErrorContainer data-testid="server-error-message">
        <FontAwesomeIcon icon={faDizzy} size="6x" className="!mb-4" />
        <p>{message}</p>

        <Link to={url} className="btn btn-primary">
            {buttonLabel}
        </Link>
    </ServerErrorContainer>
)

export default ServerErrorMessage
